import * as React from 'react'
import { useCallback, useState } from 'react'
import { ConfigProvider, Menu, MenuProps } from 'antd'
import { PageProps } from '../'
import Report from './reports'
import Resource from './resource'
import Notifications from './notifications'

const items: MenuProps['items'] = [
  {
    label: 'Reports',
    key: 'reports',
  },
  {
    label: 'Resources',
    key: 'resources',
  },
  {
    label: 'Notifications',
    key: 'notifications',
  },
]

const TabMenu: React.FC<PageProps & { setReady: React.Dispatch<React.SetStateAction<boolean>> }> = ({
  userName,
  loginToken,
  setReady,
}) => {
  const [tabKey, setTabKey] = useState('reports')

  const onClick: MenuProps['onClick'] = useCallback((e: { key: string }) => {
    setTabKey(e.key)
  }, [])

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            colorPrimary: '#316BFF',
            colorText: 'rgba(0, 0, 0, 0.88)',
            colorTextLightSolid: '#316BFF',
            colorBgContainer: '#fff',
            controlItemBgActive: '#F9FEFB',
          },
        },
      }}>
      <div style={{ width: '100%', overflowX: 'scroll', padding: '0 8px', backgroundColor: '#ffffff' }}>
        <Menu style={{ minWidth: '500px' }} mode='horizontal' items={items} onClick={onClick} selectedKeys={[tabKey]} />
      </div>
      <div style={{ backgroundColor: '#f5f5f5' }}>
        {tabKey === 'reports' && (
          <>
            <Report userName={userName} loginToken={loginToken} setReady={setReady} />
          </>
        )}
        {tabKey === 'resources' && (
          <>
            <Resource />
          </>
        )}
        {tabKey === 'notifications' && (
          <Notifications userName={userName} loginToken={loginToken} />
        )}
      </div>
    </ConfigProvider>
  )
}

export default TabMenu
